import { render, staticRenderFns } from "./TariffFullBurn.vue?vue&type=template&id=0b85e22a&scoped=true"
import script from "./TariffFullBurn.vue?vue&type=script&lang=js"
export * from "./TariffFullBurn.vue?vue&type=script&lang=js"
import style0 from "./TariffFullBurn.vue?vue&type=style&index=0&id=0b85e22a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b85e22a",
  null
  
)

export default component.exports